import React, { useState, useEffect, useRef, useCallback } from "react";
import { View, Text, Image, TextInput, TouchableOpacity } from "react-native";
import i18n from "../components/i18n";

const CaptchaConfirm = (props) => {
    const [code, setCode] = useState("")
    const [captchaCode, setCaptchaCode] = useState("")
    const [codeErr, setCodeErr] = useState(false)

    useEffect(() => {
        console.log("Cimg")
        console.log(props.captchaImg)
    }, [])

    const confirmAction = () => {
        setCodeErr(false)

        if (!code) {
            setCodeErr(true)
            return
        } else {
            props.callback(code)
        }
    }

    const genCaptcha = () => {
        const charsArray =
            "abcdefhkmnorstuvwxzABCDEFGHJKLMNOPRSTUVWXYZ";
        const lengthOtp = 4;
        let captcha = [];

        for (var i = 0; i < lengthOtp; i++) {
            var index = Math.floor(Math.random() * charsArray.length);

            if (captcha.indexOf(charsArray[index]) == -1)
                captcha.push(charsArray[index]);
            else i--;
        }

        setCaptchaCode(captcha.join(""));
    };

    return (
        <View
            className="top-0 right-0 bottom-0 left-0 justify-center items-center bg-[#00000075]"
            style={{ position: "fixed" }}
        >
            <View className="justify-center items-center w-full" >
                <View className="w-10/12 max-w-sm m-auto bg-white rounded-2xl px-7 pt-8 pb-8 text-center shadow-sm shadow-gray-300">
                    <Text className="text-center font-Crimson text-lg text-black uppercase" style={{ fontFamily: 'CrimsonText-Regular' }}>{i18n.t("captcha.title")}</Text>
                    <Text className="font-Crimson text-black mt-2 text-center uppercase" style={{ fontFamily: 'CrimsonText-Regular' }}>{i18n.t("captcha.intro")}</Text>

                    <View className="mt-5 relative">
                        {/* <Text className="h-14 w-full text-center border border-light-pink color-black p-4 text-2xl leading-7 rounded-2xl font-FuturaPT-Medium tracking-[8px]" style={{ fontFamily: 'FuturaPTMedium' }}>{captchaCode}</Text> */}

                        <View className="h-14 w-full rounded-[8px] overflow-hidden">
                            <Image className="w-[200px] h-[50px] m-auto ml-[30%]" source={{ uri: (props.captchaImg + "&width=200&height=50"), }} />
                        </View>
                        <View className="w-full h-full absolute bg-ffffff00"></View>
                    </View>

                    <View className="mt-2">
                        <TextInput onChangeText={(value) => setCode(value)} value={code} maxLength={4} autoCorrect={false} spellCheck={false} className="h-10 w-full text-center bg-[#F2F3F5] color-[#121212] p-1 text-2xl leading-9.5"></TextInput>
                    </View>

                    {(props.captchaErr || codeErr) && <Text className="text-center font-FuturaPT-Book color-red-500" style={{ fontFamily: 'FuturaPTBook' }}>{i18n.t("captcha.error")}</Text>}

                    <TouchableOpacity className="w-full h-[40px] max-h-[40px] m-auto bg-brandgold border-brandgold border mt-8 flex flex-col justify-center px-4" onPress={() => { confirmAction() }} >
                        <Text className="font-PingFangSC text-white w-full text-center text-base uppercase" style={{ fontFamily: 'PingFang-SC-Regular' }}>{i18n.t("captcha.confirm")}</Text>
                    </TouchableOpacity>

                    {/* <TouchableOpacity className="w-full h-[50px] max-h-[50px] m-auto bg-white mt-4 flex flex-col justify-center" onPress={() => { cancelAction() }} >
                    <Text className="font-FuturaPT-Bold text-[#EB5757] w-full text-center text-base" style={{ fontFamily: 'FuturaPTBold' }}>{cancelBtn}</Text>
                </TouchableOpacity> */}

                    <TouchableOpacity className="absolute top-4 right-4" onPress={() => { props.closeBtnAction() }} >
                        <Text>X</Text>
                        {/* <Image className="w-8 h-8 m-auto" source={require("@/assets/images/btn-close-2-2x.png")} /> */}
                    </TouchableOpacity>
                </View>
            </View>
        </View>

    )
}

export default CaptchaConfirm